import React from "react";
import { useParams } from "react-router-dom";
import projects from "../data/projects";
import ProjectLayout from "./projects/ProjectLayout";

export default function ProjectDetail() {
  const { id } = useParams();
  const project = projects.find((p) => p.id === id);

  return <ProjectLayout project={project} />;
}
